(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clx-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || 'USD'
        }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const initializeBundle = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const packButtons = [...root.querySelectorAll('[data-pack-size]')];
      const rows = [...root.querySelectorAll('[data-bundle-slot]')];
      const addButton = root.querySelector('[data-bundle-add]');
      const message = root.querySelector('[data-bundle-message]');
      const subtotalElement = root.querySelector('[data-bundle-subtotal]');
      const discountElement = root.querySelector('[data-bundle-discount]');
      const discountLabel = root.querySelector('[data-bundle-discount-label]');
      const totalElement = root.querySelector('[data-bundle-total]');
      const currency = root.dataset.currency || 'USD';

      if (!packButtons.length || !rows.length || !addButton) return;

      let packSize = Number(root.dataset.defaultPackSize || 2);
      let discountPercent = packSize <= 4 ? 10 : 20;

      const getActiveSelects = () => rows
        .slice(0, packSize)
        .map((row) => row.querySelector('[data-variant-select]'))
        .filter(Boolean);

      const updateSummary = () => {
        const subtotal = getActiveSelects().reduce((sum, select) => {
          const option = select.options[select.selectedIndex];
          return sum + Number(option?.dataset.price || 0);
        }, 0);
        const discountAmount = Math.round(subtotal * (discountPercent / 100));
        const total = subtotal - discountAmount;

        subtotalElement.textContent = formatMoney(subtotal, currency);
        discountElement.textContent = `−${formatMoney(discountAmount, currency)}`;
        discountLabel.textContent = `${discountPercent}% bundle discount`;
        totalElement.textContent = formatMoney(total, currency);
      };

      const setPackSize = (nextPackSize) => {
        packSize = nextPackSize;
        discountPercent = packSize <= 4 ? 10 : 20;

        packButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(Number(button.dataset.packSize) === packSize));
        });

        rows.forEach((row, index) => {
          const select = row.querySelector('[data-variant-select]');
          const isActive = index < packSize;
          row.hidden = !isActive;
          if (select) select.disabled = !isActive;
        });

        message.textContent = '';
        updateSummary();
      };

      packButtons.forEach((button) => {
        button.addEventListener('click', () => setPackSize(Number(button.dataset.packSize)));
      });

      rows.forEach((row) => {
        row.querySelector('[data-variant-select]')?.addEventListener('change', updateSummary);
      });

      addButton.addEventListener('click', async () => {
        const activeSelects = getActiveSelects();
        const selections = activeSelects.map((select) => select.value).filter(Boolean);

        if (selections.length !== packSize) {
          message.textContent = `Choose all ${packSize} bands before adding the bundle.`;
          return;
        }

        const grouped = selections.reduce((map, variantId) => {
          map.set(variantId, (map.get(variantId) || 0) + 1);
          return map;
        }, new Map());

        const bundleId = `clx-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const items = [...grouped.entries()].map(([id, quantity]) => ({
          id: Number(id),
          quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_size: `${packSize}-pack`,
            _bundle_discount: `${discountPercent}%`
          }
        }));

        const originalText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Adding bundle…';
        message.textContent = '';

        try {
          const rootUrl = root.dataset.rootUrl || '/';
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || 'The bundle could not be added to the cart.');
          }

          const discountCode = discountPercent === 20
            ? root.dataset.discountCode20
            : root.dataset.discountCode10;
          const cartUrl = root.dataset.cartUrl || '/cart';

          if (discountCode) {
            window.location.assign(`/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartUrl)}`);
          } else {
            window.location.assign(cartUrl);
          }
        } catch (error) {
          message.textContent = error.message || 'The bundle could not be added to the cart.';
          addButton.disabled = false;
          addButton.textContent = originalText;
        }
      });

      const slider = root.querySelector('[data-bundle-slider]');
      if (slider) {
        const track = slider.querySelector('[data-slider-track]');
        const slides = [...slider.querySelectorAll('[data-slider-slide]')];
        const dots = [...slider.querySelectorAll('[data-slider-dot]')];
        const previousButton = slider.querySelector('[data-slider-prev]');
        const nextButton = slider.querySelector('[data-slider-next]');
        const autoplay = slider.dataset.autoplay === 'true';
        const interval = Number(slider.dataset.interval || 5000);
        let currentSlide = 0;
        let autoplayTimer;

        const showSlide = (index) => {
          if (!slides.length || !track) return;
          currentSlide = (index + slides.length) % slides.length;
          track.style.transform = `translateX(-${currentSlide * 100}%)`;
          dots.forEach((dot, dotIndex) => {
            dot.setAttribute('aria-pressed', String(dotIndex === currentSlide));
          });
        };

        const stopAutoplay = () => {
          if (autoplayTimer) window.clearInterval(autoplayTimer);
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (autoplay && slides.length > 1) {
            autoplayTimer = window.setInterval(() => showSlide(currentSlide + 1), interval);
          }
        };

        previousButton?.addEventListener('click', () => {
          showSlide(currentSlide - 1);
          startAutoplay();
        });

        nextButton?.addEventListener('click', () => {
          showSlide(currentSlide + 1);
          startAutoplay();
        });

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            showSlide(Number(dot.dataset.sliderDot || 0));
            startAutoplay();
          });
        });

        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
        slider.addEventListener('focusin', stopAutoplay);
        slider.addEventListener('focusout', startAutoplay);

        showSlide(0);
        startAutoplay();
      }

      setPackSize(packSize);
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-clx-bundle-builder]').forEach(initializeBundle);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbb-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency || 'USD'
        }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const initializeBundle = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const packButtons = [...root.querySelectorAll('[data-pack-size]')];
      const rows = [...root.querySelectorAll('[data-bundle-slot]')];
      const addButton = root.querySelector('[data-bundle-add]');
      const message = root.querySelector('[data-bundle-message]');
      const subtotalElement = root.querySelector('[data-bundle-subtotal]');
      const discountElement = root.querySelector('[data-bundle-discount]');
      const discountLabel = root.querySelector('[data-bundle-discount-label]');
      const totalElement = root.querySelector('[data-bundle-total]');
      const currency = root.dataset.currency || 'USD';

      if (!packButtons.length || !rows.length || !addButton) return;

      let packSize = Number(root.dataset.defaultPackSize || 2);
      let discountPercent = packSize <= 4 ? 10 : 20;

      const getActiveSelects = () => rows
        .slice(0, packSize)
        .map((row) => row.querySelector('[data-variant-select]'))
        .filter(Boolean);

      const updateSummary = () => {
        const subtotal = getActiveSelects().reduce((sum, select) => {
          const option = select.options[select.selectedIndex];
          return sum + Number(option?.dataset.price || 0);
        }, 0);
        const discountAmount = Math.round(subtotal * (discountPercent / 100));
        const total = subtotal - discountAmount;

        subtotalElement.textContent = formatMoney(subtotal, currency);
        discountElement.textContent = `−${formatMoney(discountAmount, currency)}`;
        discountLabel.textContent = `${discountPercent}% bundle discount`;
        totalElement.textContent = formatMoney(total, currency);
      };

      const setPackSize = (nextPackSize) => {
        packSize = nextPackSize;
        discountPercent = packSize <= 4 ? 10 : 20;

        packButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(Number(button.dataset.packSize) === packSize));
        });

        rows.forEach((row, index) => {
          const select = row.querySelector('[data-variant-select]');
          const isActive = index < packSize;
          row.hidden = !isActive;
          if (select) select.disabled = !isActive;
        });

        message.textContent = '';
        updateSummary();
      };

      packButtons.forEach((button) => {
        button.addEventListener('click', () => setPackSize(Number(button.dataset.packSize)));
      });

      rows.forEach((row) => {
        row.querySelector('[data-variant-select]')?.addEventListener('change', updateSummary);
      });

      addButton.addEventListener('click', async () => {
        const activeSelects = getActiveSelects();
        const selections = activeSelects.map((select) => select.value).filter(Boolean);

        if (selections.length !== packSize) {
          message.textContent = `Choose all ${packSize} bands before adding the bundle.`;
          return;
        }

        const grouped = selections.reduce((map, variantId) => {
          map.set(variantId, (map.get(variantId) || 0) + 1);
          return map;
        }, new Map());

        const bundleId = `clx-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const items = [...grouped.entries()].map(([id, quantity]) => ({
          id: Number(id),
          quantity,
          properties: {
            _bundle_id: bundleId,
            _bundle_size: `${packSize}-pack`,
            _bundle_discount: `${discountPercent}%`
          }
        }));

        const originalText = addButton.textContent;
        addButton.disabled = true;
        addButton.textContent = 'Adding bundle…';
        message.textContent = '';

        try {
          const rootUrl = root.dataset.rootUrl || '/';
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.description || 'The bundle could not be added to the cart.');
          }

          const discountCode = discountPercent === 20
            ? root.dataset.discountCode20
            : root.dataset.discountCode10;
          const cartUrl = root.dataset.cartUrl || '/cart';

          if (discountCode) {
            window.location.assign(`/discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartUrl)}`);
          } else {
            window.location.assign(cartUrl);
          }
        } catch (error) {
          message.textContent = error.message || 'The bundle could not be added to the cart.';
          addButton.disabled = false;
          addButton.textContent = originalText;
        }
      });

      const slider = root.querySelector('[data-bundle-slider]');
      if (slider) {
        const track = slider.querySelector('[data-slider-track]');
        const slides = [...slider.querySelectorAll('[data-slider-slide]')];
        const dots = [...slider.querySelectorAll('[data-slider-dot]')];
        const previousButton = slider.querySelector('[data-slider-prev]');
        const nextButton = slider.querySelector('[data-slider-next]');
        const autoplay = slider.dataset.autoplay === 'true';
        const interval = Number(slider.dataset.interval || 5000);
        let currentSlide = 0;
        let autoplayTimer;

        const showSlide = (index) => {
          if (!slides.length || !track) return;
          currentSlide = (index + slides.length) % slides.length;
          track.style.transform = `translateX(-${currentSlide * 100}%)`;
          dots.forEach((dot, dotIndex) => {
            dot.setAttribute('aria-pressed', String(dotIndex === currentSlide));
          });
        };

        const stopAutoplay = () => {
          if (autoplayTimer) window.clearInterval(autoplayTimer);
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (autoplay && slides.length > 1) {
            autoplayTimer = window.setInterval(() => showSlide(currentSlide + 1), interval);
          }
        };

        previousButton?.addEventListener('click', () => {
          showSlide(currentSlide - 1);
          startAutoplay();
        });

        nextButton?.addEventListener('click', () => {
          showSlide(currentSlide + 1);
          startAutoplay();
        });

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            showSlide(Number(dot.dataset.sliderDot || 0));
            startAutoplay();
          });
        });

        slider.addEventListener('mouseenter', stopAutoplay);
        slider.addEventListener('mouseleave', startAutoplay);
        slider.addEventListener('focusin', stopAutoplay);
        slider.addEventListener('focusout', startAutoplay);

        showSlide(0);
        startAutoplay();
      }

      setPackSize(packSize);
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-clx-bundle-builder]').forEach(initializeBundle);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
